export default "__VITE_ASSET__DaBWmkBm__"